import { toast } from 'react-toastify';
import { parseApiError } from './apiValidationErrors';

/** Shape shared by every generated `OperationResponse` (one per API package). */
export interface OperationResult {
  isSuccess?: boolean;
  errorMessage?: string | null;
}

/**
 * Runs an API call that answers with an OperationResponse and turns its outcome into a boolean.
 * A refusal (`isSuccess` false) shows the back's message, a thrown error shows the parsed API
 * message; `fallbackMessage` is shown when neither carries a text. Never throws.
 */
export async function runOperation(
  call: () => Promise<OperationResult | null | undefined>,
  fallbackMessage: string
): Promise<boolean> {
  try {
    const response = await call();
    if (!response?.isSuccess) {
      toast.error(response?.errorMessage || fallbackMessage);
      return false;
    }
    return true;
  } catch (error) {
    const parsed = await parseApiError(error);
    toast.error(parsed.message || fallbackMessage);
    return false;
  }
}
